module.exports = {
  mode: 'jit',
  purge: ['./src/**/*.{js,jsx,ts,tsx}', '../utils/**/*.{js,jsx,ts,tsx}'],
  future: {
    purgeLayersByDefault: true,
    removeDeprecatedGapUtilities: true,
  },
  theme: {
    spacing: {
      px: '1px',
      0: '0px',
      0.5: '2px',
      1: '4px',
      1.5: '6px',
      2: '8px',
      2.5: '10px',
      3: '12px',
      3.5: '14px',
      4: '16px',
      5: '20px',
      6: '24px',
      7: '28px',
      8: '32px',
      9: '36px',
      10: '40px',
      11: '44px',
      12: '48px',
      14: '56px',
      16: '64px',
      20: '80px',
      24: '96px',
      28: '112px',
      32: '128px',
      36: '144px',
      40: '160px',
      44: '176px',
      48: '192px',
      52: '208px',
      56: '224px',
      60: '240px',
      64: '256px',
      72: '288px',
      80: '320px',
      96: '384px',
    },
    borderRadius: {
      none: '0px',
      sm: '2px',
      DEFAULT: '4px',
      md: '6px',
      lg: '8px',
      xl: '12px',
      '2xl': '16px',
      '3xl': '24px',
      full: '9999px',
    },
    fontSize: {
      xs: ['12px', { lineHeight: '16px' }],
      sm: ['14px', { lineHeight: '20px' }],
      base: ['16px', { lineHeight: '24px' }],
      lg: ['18px', { lineHeight: '28px' }],
      xl: ['20px', { lineHeight: '28px' }],
      '2xl': ['24px', { lineHeight: '32px' }],
      '3xl': ['30px', { lineHeight: '36px' }],
      '4xl': ['36px', { lineHeight: '40px' }],
      '5xl': ['48px', { lineHeight: '1' }],
      '6xl': ['60px', { lineHeight: '1' }],
      '7xl': ['72px', { lineHeight: '1' }],
      '8xl': ['96px', { lineHeight: '1' }],
      '9xl': ['128px', { lineHeight: '1' }],
    },
    lineHeight: {
      none: '1',
      tight: '1.25',
      snug: '1.375',
      normal: '1.5',
      relaxed: '1.625',
      loose: '2',
      3: '12px',
      4: '16px',
      5: '20px',
      6: '24px',
      7: '28px',
      8: '32px',
      9: '36px',
      10: '40px',
    },
    maxWidth: ({ theme, breakpoints }) => ({
      none: 'none',
      0: '0px',
      xs: '320px',
      sm: '384px',
      md: '448px',
      lg: '512px',
      xl: '576px',
      '2xl': '672px',
      '3xl': '768px',
      '4xl': '896px',
      '5xl': '1024px',
      '6xl': '1152px',
      '7xl': '1280px',
      full: '100%',
      min: 'min-content',
      max: 'max-content',
      fit: 'fit-content',
      prose: '65ch',
      ...breakpoints(theme('screens')),
    }),
    extend: {
      fontFamily: {
        sans: ['"DM Sans"', 'sans-serif'],
        mono: ['"DM Mono"', 'monospace'],
      },
      fontWeight: {
        normal: '400',
        medium: '500',
        semibold: '600',
        bold: '700',
      },
      spacing: {
        128: '512px',
      },
      colors: {
        success: '#059669',
        warning: '#FFF157',
        error: '#E23A49',
        foreground: 'var(--foreground)',
        background: 'var(--background)',
        'foreground-text': 'var(--foreground-text)',
        'background-text': 'var(--background-text)',
        neutral: {
          900: '#000',
          800: '#070217',
          700: '#0D0626',
          600: '#1F1837',
          500: '#2D2841',
          400: '#4C4859',
          350: '#8A8699',
          300: '#C2BFCD',
          200: '#DBDCDD',
          100: '#F3F4F6',
          50: '#F6F5FA',
        },
        'grays-anatomy': {
          500: '4B5563',
        },
        'international-orange': {
          50: '#FFF7F3',
          100: '#FFEEE8',
          200: '#FFD5C5',
          300: '#FFBCA3',
          400: '#FE8A5D',
          500: '#FE5818',
          600: '#E54F16',
          700: '#98350E',
          800: '#72280B',
          900: '#4C1A07',
        },
        'wild-strawberry': {
          50: '#FFF4F9',
          100: '#FFEAF4',
          150: '#FFEBF5',
          200: '#FFCAE2',
          300: '#FFABD1',
          400: '#FF6BAF',
          500: '#FF2C8C',
          600: '#E6287E',
          700: '#991A54',
          800: '#73143F',
          900: '#4D0D2A',
        },
        fuchsia: {
          50: '#FFF2FF',
          100: '#FFE6FF',
          200: '#FFBFFF',
          300: '#FF99FF',
          400: '#FF4DFF',
          500: '#FF00FF',
          600: '#E600E6',
          700: '#990099',
          800: '#730073',
          900: '#4D004D',
        },
        'deep-purple': {
          50: '#bba8ff',
          100: '#997dff',
          200: '#8867ff',
          300: '#7751ff',
          400: '#663cff',
          500: '#5526ff',
          550: '#EEE9FF',
          600: '#4d22e6',
          700: '#441ecc',
          800: '#3b1bb3',
          900: '#331799',
        },
      },
      width: {
        inherit: 'inherit',
      },
    },
  },
  variants: {
    extend: {
      borderWidth: ['last'],
    },
  },
}
